import React from "react";
import { Col, Row } from "reactstrap";

const ContentPage = ({ component: Component }) => {

    return (
        <div className="content">
            <Row>
                <Col md="12">
                    {<Component />}
                </Col>
            </Row>
        </div>
    );
}

export default ContentPage;
